import request from '@/utils/request'

let Warehouse_inventoryApi = {


        //盘点
        calculateInventory(data) {
            return request._post('/shop/plus.warehouse_inventory.Index/calculateInventory', data);
        },
    
    //确认盘点
    confirmInventory(data) {
        return request._post('/shop/plus.warehouse_inventory.Index/confirmInventory', data);
    },


  /*仓库盘点列表*/
  list(data) {
    return request._post('/shop/plus.warehouse_inventory.Index/index', data);
},
/*添加仓库盘点*/
add(data) {
    return request._post('/shop/plus.warehouse_inventory.Index/add', data);
},
/*修改仓库盘点*/
edit(data) {
    return request._post('/shop/plus.warehouse_inventory.Index/edit', data);
},
/*删除仓库盘点*/
del(data) {
    return request._post('/shop/plus.warehouse_inventory.Index/del', data);
},
passCanel(data) {
    return request._post('/shop/plus.warehouse_inventory.Index/passCanel', data);
},
/*仓库盘点详情*/
detail(data) {
  return request._post('/shop/plus.warehouse_inventory.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.warehouse_inventory.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.warehouse_inventory.Setting/getSetting', data, errorback);
    },
}
export default Warehouse_inventoryApi;



// WEBPACK FOOTER //
// ./src/api/warehouse_inventory.js